import { apiClient } from '.';

export interface BenepiaUser {
  _id: string;
  name: string;
  phone?: string;
  sitecode?: string;
  sitename?: string;
  deletedAt?: Date;
  privacyPolicyAgree?: boolean;
  marketingAgree?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface SearchBenepiaUsersQuery {
  page?: number;
  size?: number;
  keyword?: string;
  startDate?: string;
  endDate?: string;
  sort?: string;
}

export interface BenepiaUsersContainer {
  page: number;
  size: number;
  total: number;
  hasNext: boolean;
  contents: BenepiaUser[];
}

export const searchBenepiaUsers = (query: SearchBenepiaUsersQuery) => {
  return apiClient.get(`benepia/v1/admin/users`, {
    params: query,
  });
};

export const getSearchBenepiaUsersExcelFile = async (query?: SearchBenepiaUsersQuery) => {
  return apiClient.get(`benepia/v1/admin/users/export`, {
    params: query,
    responseType: 'blob',
    headers: { 'Cache-Control': 'no-cache' },
  });
};

export const getBenepiaUser = (userId: string) => {
  return apiClient.get(`admin/v1/benepia/users/${userId}`);
};

export const updateBenepiaUser = (userId: string, data: Partial<BenepiaUser>) => {
  return apiClient.put(`admin/v1/benepia/users/${userId}`, data);
};

export const deleteBenepiaUser = (userId: string) => {
  return apiClient.delete(`admin/v1/benepia/users/${userId}`);
};

export const getBenepiaMainFeed = () => {
  return apiClient.get(`benepia/v1/admin/feed/main-feed`);
};

export const updateBenepiaMainFeed = (formData: FormData) => {
  return apiClient.put(`benepia/v1/admin/feed/main-feed`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
